<template>
  <div class="lesson">
    <div class="lesson-time" :style="{borderColor: event.color}">
      {{$filters.LT(event.start_time)}}
      <br>
      {{$filters.LT(event.end_time)}}
    </div>
    <div> {{event.title}}<span v-if="eventHasAnyKlass(event.klasses)">,</span>
      {{event.klasses | klassList}}<br>
      <span class="meta-info">{{showType}}</span>
    </div>
    <div v-if="event.substitute_for"><span class="icon-users3"></span>{{ $t('vue2.substitute_hours.substitute_for')}}:
      {{event.substitute_for}}
    </div>
    <div class="align-right">{{eventDuration}}</div>
  </div>
</template>

<script>
  import {isSubstitute} from '../../utils/userEventsFilter'

  export default {
    props: {
      event: {
        type: Object
      },
      activeFilter: {
        type: String,
        default: ''
      },
      // Kun events fra api.school_user_events.read har event.substitutes
      userId: {
        type: Number,
        default: null
      }
    },
    computed: {
      eventDuration () {
        if (this.activeFilter !== 'absence' && this.event.event_type === 'absence') {
          return ''
        }
        return this.event.calendar_event_duration + ' min.'
      },
      showType () {
        const isSubstituteHour = this.userId !== null ? isSubstitute(this.event, this.userId) : this.event.substitute_for !== null
        if (isSubstituteHour) {
          return this.$i18n.t('vue2.substitute_hours.substitute_hour')
        } else if (this.event.event_type === 'absence') {
          return this.$i18n.t('vue2.substitute_hours.absence')
        } else if (this.event.event_type === 'other_tasks') {
          return this.$i18n.t('vue2.substitute_hours.other_tasks')
        } else if (this.event.event_type === 'other_stuff') {
          return this.$i18n.t('vue2.substitute_hours.other_stuff')
        } else {
          return ''
        }
      }
    },
    filters: {
      klassList (string) {
        return string.replace(/{|}/g, '')
      }
    },
    methods: {
      eventHasAnyKlass (event) {
        let str = event.replace(/{|}/g, '')
        return str.length > 0
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .lesson {
    display: flex;
    padding: 4px 10px;
    border-bottom: 1px solid var(--border-color);
  }

  .lesson > div {
    flex: 1;
    align-items: center;
  }

  .lesson-time {
    border-right: 2px solid black;
    margin-right: 10px;
    max-width: 75px;
  }

  .meta-info {
    color: #999999;
    font-size: 11px;
  }

  .align-right {
    text-align: right;
  }

</style>



// WEBPACK FOOTER //
// Lesson.vue?99057716